module.exports = __webpack_public_path__ + "fonts/icomoon.0ebba85.woff";